import styled from 'styled-components';

interface WrapperContentProps {
	justFinish?: boolean;
}

export const WrapperContent = styled.div<WrapperContentProps>`
	background-color: ${({ theme }) => theme.colors.principal.air};
	display: flex;
	flex-flow: row wrap;
	justify-content: ${({ justFinish }) => (justFinish ? 'center' : 'space-between')};
	padding: 24px 16px;
`;

export const ButtonContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;
	width: 100%;

	div {
		width: 70%;
	}
`;
